import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { ClientService } from '../services/client.service';

@Component({
  selector: 'app-client-request',
  templateUrl: './client-request.component.html',
  styleUrls: ['./client-request.component.scss']
})

export class ClientRequestComponent implements OnInit, OnDestroy {
  public accessRoles: any;
  public uuid: string = '';

  public selectedGender = "Both";
  public isResetForm = false;
  public quoteObj: any = [];
  public quoteObjSection: any = {};
  public previousRequest = "";
  public editClientRequestDataCont: any = {};
  constructor(
    public clientService: ClientService,
    public sanitization: DomSanitizer,
    private notifier: NotifierService,
    private router: Router,
    private activaterRoute: ActivatedRoute
  ) {
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    this.clientService.expressSaveId = this.uuid;

  }

  ngOnInit(): void {
    this.clientService.isSearchShow = false;
    this.clientService.expressSaveId = this.uuid;
    this.getForm();
  }

  ngOnDestroy(): void {
    this.clientService.eid = "";
    this.clientService.expressSaveId = "";
    this.clientService.expressUUid = "";
    this.clientService.savePayloadObject = {};
    this.clientService.savePrevPayloadObject = "";
    this.editClientRequestDataCont = {};
  }

  getForm() {
    let query = this.uuid && this.uuid != "" ? { "uuid": this.uuid } : {};
    this.clientService.getForm(query).subscribe((result) => {
      if (result["status"] == 1) {
        this.quoteObj = result['data'];
        this.quoteObjSection = {};
        this.initQuoteObj();
        if (this.uuid && this.uuid != '') {
          setTimeout(() => {
            this.getClientRequestDetails();
          }, 100)
        }
      } else {
        this.notifier.notify('error', 'Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error', 'Something went wrong !');
    })
  }

  getClientRequestDetails() {
    this.clientService.getClientRequestDetails(this.uuid).subscribe((result) => {
      if (result["status"] == 1) {
        this.editClientRequestDataCont = result['data'];
        this.setFormDetails(result);
      } else {
        this.notifier.notify('error', 'Something went wrong !');
      }
    })
  }

  setFormDetails(result: any) {
    let dependentFieldCheck = [];
    this.quoteObj.forEach((field) => {
      if(field.key == 'is_parent_or_billing'){
        Object.keys(field.value).forEach((key) => {
          if (field.value[key].label != result['data'][field.key]) {
            field.value[key]['hide'] = true;
          }
        })
      }
      

      if (field.key == 'invoicing_tracking_study') {
        field.selectedValue = result['data'][field.key] ? JSON.parse(result['data'][field.key]) : [{ "percent": "", "term": "" }];

      }else if (field.key == 'invoicing_adhoc_study') {
        field.selectedValue = result['data'][field.key] ? JSON.parse(result['data'][field.key]) : [{
          "percent": "",
          "term": ""
        }];
      }else {
        field.selectedValue = result['data'][field.key] ? result['data'][field.key] : "";
      }

      


      if (field["dependent"] && field["dependent"]["to"] || (field["key"]=="gender" && field["selectedValue"] != "")) {
        dependentFieldCheck.push(field);
      }
      if(field.key == 'gst' && field.selectedValue && field.selectedValue != ''){
        this.setCountryAndStateCode(field);
      }
      if(field.key == 'state' && result['data'] && result['data']['gst'] != ''){
        this.setCountryAndStateCode(this.quoteObj.find((item) => item.key == 'gst'));
      }

      if(field.key == 'state' && result['data'] && result['data']['country_code'] != ''){
        if(result['data']['country_code'] != 'IN'){
          field.show = false;
        }else{
          field.show = true;
        }
      }
    })
    dependentFieldCheck.forEach((field) => {
      if (field.type == 'radio') {
        this.onRadioChange(field,true);
      }else{
        this.checkOtherDependent(field,true);
      }
    })

    // console.log("dependentFieldCheck ====>", this.quoteObj);

  }

  checkOtherDependent(field, isReassign?:boolean){
    let dependent = field.dependent ? field.dependent : null;
    if (dependent && dependent.to) {
      this.checkDependent(dependent.to,field,field.selectedValue,isReassign);
    }
    if (isReassign) {
      // this.appendToQuoteObjPayload(field, true);
    }else{
      this.appendToQuoteObjPayload(field);
    }
  }

  initQuoteObj() {
    let dependentFieldCheck = [];
    this.clientService.showDataSaving = false;
    this.quoteObj.forEach((field, index) => {
      this.quoteObjSection[field.group_label] = this.quoteObjSection[field.group_label] ? this.quoteObjSection[field.group_label] : { 'values': [] };
      this.quoteObjSection[field.group_label]["show"] = field.group_label == 'Basic Details' ? true : true;
      field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' ? field["selectedValue"] : field["selected_value"] && field["selected_value"] != '' ? field["selected_value"] : field["selectedValue"] >= 0 ? field["selectedValue"] : "";
      if (field["type"] == 'from-to') {
        field["selectedValue"] = { from: "", to: "" };
      } else if (field["type"] == 'percent-term') {
        field["selectedValue"] = field["selectedValue"] && (field["selectedValue"] != null || field["selectedValue"] != '') ? JSON.parse(field["selectedValue"]) : [{ "percent": "", "term": "" }];
        this.parsePlaceholder(field);
      } else if (field["type"] == 'single-select' && field["disabled"]) {
        let option = Object.values(field["value"]).find((item) => { return item["selected"] && item["selected"] == true });
        field["selectedValue"] = option && option["label"] ? option["label"] : "";
      }
      if (field["type"] == 'single-select' || field["type"] == 'multi-select' || field["type"] == 'single-select-obj' || field["type"] == 'multi-select-obj') {
        field["filteredValue"] = JSON.parse(JSON.stringify(field["value"]));
      }
      field['defaultShow'] = field['show'] ? true : false;
      if(!this.uuid){
        if(field.key != 'is_parent_or_billing'){
        field['show'] = false;
      }}
      if (field["dependent"] && field["dependent"]["to"] && field["selectedValue"] != "") {
        dependentFieldCheck.push(field);
      }
      this.quoteObjSection[field.group_label]["values"].push(field);
    });
    dependentFieldCheck.forEach((field) => {
      if (field.type == 'radio') {
        this.onRadioChange(field,false);
      }else{
        this.checkOtherDependent(field,false);
      }
    })
    // console.log("this.quoteObjSection ====>", this.quoteObj);
    // console.log("dependentFieldCheck ===> ",dependentFieldCheck);

  }

  checkSection() {
    if (this.quoteObjSection && Object.keys(this.quoteObjSection).length) {
      return true;
    } else {
      return false;
    }
  }

  onRadioChange(field, isReassign?: boolean) {
    if (!isReassign && field && field.key == 'is_parent_or_billing') {
      this.quoteObj.forEach((item) => {
        item.show = item.defaultShow
      })      
    }
    if (this.validateField(field)) {
      let dependent = field.dependent ? field.dependent : null;
      if (dependent && dependent.to) {
        this.checkDependent(dependent.to, field, field.selectedValue, isReassign);
      }
      console.log("field.selectedValue ====> ",field.selectedValue);
      console.log("isReassign ====> ",isReassign);
      if(!isReassign){
        this.appendToQuoteObjPayload(field);
      }
    }
  }

parsePlaceholder(field:any) {
    try {
      field["placeholder"] = field["placeholder"] && typeof field["placeholder"] === 'string'
        ? JSON.parse(field["placeholder"])
        : field["placeholder"];
    } catch (e) {
      field["placeholder"] = field["placeholder"];
    }
  }

  onInputFiledFocusOut(field: any) {
    let value = field.selectedValue + "";
    if(field && field.key == 'gst'){
      field.required = false;
      this.resetCountryAndStateCode(field);
    }
    if (this.validateField(field)) {
      if (value == '' && field.required) {
        this.notifier.notify('error', field.label + ' is required !');
      } else {
        if(field && field.key == 'gst'){
          this.setCountryAndStateCode(field);
        }
        this.appendToQuoteObjPayload(field);
      }
    }
  }

  setCountryAndStateCode(field: any) {
    let gstStateCode = field.selectedValue;
    if (gstStateCode.length > 2) {
      let gstCode = gstStateCode.substring(0, 2);
      let countryCodeField = this.quoteObj.find((item) => item.key == 'country_code');
      if (countryCodeField) {
        countryCodeField.selectedValue = 'IN';
        this.checkDependent(countryCodeField.dependent ? countryCodeField.dependent.to : [], countryCodeField, countryCodeField.selectedValue, false);
        countryCodeField.disabled = true;
        let stateCodeField = this.quoteObj.find((item) => item.key == 'state');
        if (stateCodeField) {
          let stateCodekey = 'gst_'+gstCode;
          if (stateCodeField.value[stateCodekey]) {
            stateCodeField.disabled = true;
            stateCodeField.selectedValue = stateCodeField.value[stateCodekey].label;
            this.appendToQuoteObjPayload(countryCodeField);
            this.appendToQuoteObjPayload(stateCodeField);
          } else {
            this.notifier.notify('error', 'Invalid GST State Code!');
            stateCodeField.selectedValue = '';
          }
        }
      }
    }
  }


  resetCountryAndStateCode(field: any) {
    let countryCodeField = this.quoteObj.find((item) => item.key == 'country_code');
    let stateCodeField = this.quoteObj.find((item) => item.key == 'state');
    if(countryCodeField && stateCodeField) {
      stateCodeField.selectedValue = '';
      stateCodeField.disabled = true;
      if(this.editClientRequestDataCont && this.editClientRequestDataCont['country_code'] && this.editClientRequestDataCont['country_code'] != 'IN'){
        countryCodeField.selectedValue = this.editClientRequestDataCont['country_code'];
        if(countryCodeField.selectedValue != 'IN'){
          stateCodeField.show = false;
        }
      }else{
        countryCodeField.selectedValue = '';
      }
      countryCodeField.disabled = false;
      this.checkDependent(countryCodeField.dependent ? countryCodeField.dependent.to : [], countryCodeField, countryCodeField.selectedValue, false);
    }
  }

  onPercentTermFocusOut(field: any, rIndex) {
    // if (this.validateField(field)) {
      let id = field.key + "";
      if (field && field.selectedValue && field.selectedValue[rIndex] && field.selectedValue[rIndex].percent != "" && field.selectedValue[rIndex].term != "") {
        this.clientService.savePayloadObject[id] = [];
        this.clientService.savePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    // }

  }

  onSelectChangePercentTerm(field, option, rIndex) {
    if (this.validateField(field)) {
      let id = field.key + "";
      
      if (field && field.selectedValue && field.selectedValue[rIndex] && field.selectedValue[rIndex].percent != "" && field.selectedValue[rIndex].term != "") {
        this.clientService.savePayloadObject[id] = [];
        this.clientService.savePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
      }
    }
  }

  addPercentTerm(field) {
    field.selectedValue.push({ "percent": "", "term": "" });
  }

  removePercentTerm(field, rIndex) {
    field.selectedValue.splice(rIndex, 1);
    if (field.selectedValue.length < 1) {
      field.selectedValue.push({ "percent": "", "term": "" });
    }
  }

  onSelectChange(selectCtrl: MatSelect, field: any) {
    if (this.validateField(field)) {
      let dependent = field.dependent ? field.dependent : null;
      if (dependent && dependent.to) {
        this.checkDependent(dependent.to, field, field.selectedValue, false);
      }
      if (field && field.misc && field.misc.form_reload) {
        this.clientService.isFormReload = true;
      }
      this.appendToQuoteObjPayload(field);
    }
  }



  onObjSelectChange(selectedObjOption, field: any) {
    if(field && field.key == 'parent_client_name' && field.type == 'single-select-obj'){
      let body:any = {'id':selectedObjOption.key};
      this.clientService.getParentClientDetails(body).subscribe((response:any) => {
        if(response && response.status){
          this.quoteObj.forEach((item) => {
            if(item.key == 'parent_client_id'){
              item.selectedValue = response.res;
              this.appendToQuoteObjPayload(item);
            }
          });
        }else{
           this.quoteObj.forEach((item) => {
            if(item.key == 'parent_client_id'){
              item.selectedValue = '';
            }
          });

          this.notifier.notify('error',response.mssg || 'Something went wrong !');
        }
      })
    }
    if (field.key == 'country_code') {
      this.checkDependentForCountryCode(field, selectedObjOption);
    }
    if (this.validateField(field)) {
      let id = field.key + "";
      if (!this.clientService.savePayloadObject[id]) {
        this.clientService.savePayloadObject[id] = {};
      } else {
        this.clientService.savePayloadObject[id] = typeof this.clientService.savePayloadObject[id] === 'string' ? JSON.parse(this.clientService.savePayloadObject[id]) : this.clientService.savePayloadObject[id];
      }
      this.clientService.savePayloadObject[id]["label"] = selectedObjOption.value.label;
      this.clientService.savePayloadObject[id]["id"] = selectedObjOption.key;
    }

  }

  checkDependentForCountryCode(field: any, selectedObjOption: any) {
    let dependent = field.dependent ? field.dependent : null;
    if (selectedObjOption && selectedObjOption.key == 'IN') {
      if (dependent && dependent.to) {
        this.checkDependent(dependent.to, field, field.selectedValue, false);
      }
    } else {
      if(this.uuid && this.uuid != ''){
        this.appendToQuoteObjPayload(field);
        this.reSetGstAndStateCodeForNonINCountry();
      }
      if (dependent && dependent.to) {
        dependent.to.forEach((va) => {
          let dependentToField = this.quoteObj.find((item) => item.id == va.id);
          if (dependentToField) {
            Object.keys(va).forEach((fKey) => {
              if (fKey != "id" && fKey != "value") {
                dependentToField[fKey] = !va[fKey];
              }
            })
          }
        })
      }
    }
  }

  reSetGstAndStateCodeForNonINCountry(){
    let gstField = this.quoteObj.find((item) => item.key == 'gst');
    let stateField = this.quoteObj.find((item) => item.key == 'state');
    if (gstField) {
      gstField.selectedValue = '';
      gstField.error = false;
      // gstField.disabled = true;
      this.appendToQuoteObjPayload(gstField);
    }
    if (stateField) {
      stateField.selectedValue = '';
      stateField.show = false;
      this.appendToQuoteObjPayload(stateField);
    }
  }

  onMultiObjSelectChange(field: any) {
    if (this.validateField(field)) {
      let id = field.key + "";
      this.clientService.savePayloadObject[id] = [];
      field.selectedValue.forEach((selectedKey) => {
        this.clientService.savePayloadObject[id].push({ "id": selectedKey, "label": field.value[selectedKey].label });
      })
      if (field && field.misc && field.misc.form_reload) {
        this.clientService.isFormReload = true;
      }
      if (field && field.misc && field.misc.form_reload) {
        this.clientService.isFormReload = true;
      }
      if (field && field.misc && field.misc.auto_save) {
        this.isAnyChangeInContractSaveQuotePayload();
      }
    }
  }

  onToggleChange(field) {
    if (this.validateField(field)) {
      let id = field.key + "";
      this.clientService.savePayloadObject[id] = field.selectedValue;
      if (field && field.misc && field.misc.auto_save) {
        this.isAnyChangeInContractSaveQuotePayload();
      }
    }
  }


  isAnyChangeInContractSaveQuotePayload() {
    let currentPayload = this.clientService.savePayloadObject;
    if (!this.clientService.savePrevPayloadObject) {
      this.clientService.savePrevPayloadObject = JSON.stringify(currentPayload);
    } else {
      if (JSON.stringify(currentPayload) != this.clientService.savePrevPayloadObject) {
        this.clientService.savePrevPayloadObject = JSON.stringify(currentPayload);
      }
    }

  }

  toggleDropdown(index: number, select: MatSelect) {
    if (select.panelOpen) {
      select.close();
    } else {
      select.open();
    }
  }

  updateRelatedFields(data: any) {
    Object.keys(this.quoteObjSection).forEach((groupKey) => {
      this.quoteObjSection[groupKey]['values'].forEach((fieldObj) => {
        if (Object.keys(data).includes(fieldObj['id'] + '')) {
          fieldObj['selectedValue'] = data[fieldObj['id']]['value'];
          let isValid = this.validateField(fieldObj);
        }
      })
    })
  }

  getGridStyle(type: string, field?: any) {
    if (type === 'grid') { // condition for the item to span both columns
      return { 'grid-column': 'span 2' };
    }
    if (field && field.misc && field.misc.span) {
      let spanObj = {}
      if (field.misc.span.column) {
        spanObj['grid-column'] = 'span ' + field.misc.span.column;
      }
      if (field.misc.span.row) {
        spanObj['grid-row'] = 'span ' + field.misc.span.row;
      }
      return spanObj;
    }
    return {};
  }

  appendToQuoteObjPayload(field, isReassign?: boolean) {
    let id = field.key + "";
    // console.log("this.editClientRequestDataCont[field.key] ===> ",this.editClientRequestDataCont[field.key])
    // if(this.uuid && this.uuid != ''){
    //   if(field.selectedValue != this.editClientRequestDataCont[field.key]){
    //     this.clientService.savePayloadObject[id] = field.selectedValue;
    //   }
    // }else{
    //   this.clientService.savePayloadObject[id] = field.selectedValue;
    // }
    this.clientService.savePayloadObject[id] = field.selectedValue;
    // console.log("this.clientService.savePayloadObject[id] ===> ",this.clientService.savePayloadObject[id])
    if (field && field.misc && field.misc.auto_save && !isReassign) {
      this.isAnyChangeInContractSaveQuotePayload();
    }

  }

  checkDependent(fields, currentField, selectedValue, isReassign?:boolean) {
    if (fields && fields.length) {
      let currentFieldInQuoteObj = this.quoteObj.find((item) => item.id == currentField.id);
      let isCurrentFieldChanged = (isReassign && currentFieldInQuoteObj && currentFieldInQuoteObj.selectedValue && currentFieldInQuoteObj.selectedValue == currentField['selectedValue']) ? false : true;
      fields.forEach(field => {
        let dependentToField = this.quoteObj.find((item) => item.id == field.id);
        if (field.value.includes(selectedValue)) {
          Object.keys(field).forEach((fKey) => {
            if (fKey != "id" && fKey != "value") {
              if(fKey == 'selectedValue'){
                dependentToField[fKey] = isCurrentFieldChanged ? field[fKey] : dependentToField[fKey];
              }else{
                dependentToField[fKey] = field[fKey];
              }
                // dependentToField[fKey] = dependentToField['defaultShow'] ? true : false;
            }
            if(fKey == 'disabled' && dependentToField.key == 'state'){
              if(this.editClientRequestDataCont && this.editClientRequestDataCont['gst'] && this.editClientRequestDataCont['gst'] != '')
              dependentToField[fKey] = true
            }
                                  
          })
          this.quoteObjSection[dependentToField.group_label]["values"].forEach((fItem) => {
          if (fItem.id == field.id) {
            Object.keys(field).forEach((fKey) => {
              if (fKey != "id" && fKey != "value") {
                fItem[fKey] = dependentToField[fKey];
              }
            })
          }
        })
        }else{
          // Object.keys(field).forEach((fKey) => {
          //   if (fKey != "id" && fKey != "value") {
          //     dependentToField[fKey] = !field[fKey];
          //   }
          // })
        }
        // this.quoteObjSection[dependentToField.group_label]["values"].forEach((fItem) => {
        //   if (fItem.id == field.id) {
        //     Object.keys(field).forEach((fKey) => {
        //       if (fKey != "id" && fKey != "value") {
        //         fItem[fKey] = dependentToField[fKey];
        //       }
        //     })
        //   }
        // })
      });
    }
  }

  validateField(field: any) {
    let isValid = true;

    if (field && field.required && field.show && !field.disabled) {
      if (field.type == 'from-to') {
        if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
          isValid = false;
        }
      } else if (field.type == 'percent-term') {
        if (field.selectedValue && field.selectedValue.length < 1 || field.selectedValue.find(item => { return item.percent == "" || item.term == "" })) {
          isValid = false;
        }

      } else {
        if (field.selectedValue == "") {
          isValid = false;
        }
      }
      if (!isValid) {
        field['error'] = true;
        this.notifier.notify('error', field.label + ' is required !');
        return isValid;
      } else {
        field['error'] = false;
      }
    }
    if (field && field.show && field.validation && field.validation.length) {
      field.validation.forEach((validation) => {
        if (validation.type == "regex") {

          if (!((field.selectedValue == "" || field.selectedValue == null) && validation.allow_blank)) {
            const regex = new RegExp(validation.value);
            isValid = regex.test(field.selectedValue);
            if (!isValid) {
              this.notifier.notify('error', validation.message);
              isValid = false;
              return isValid;
            }
          }
        } else if (validation.type == "total-invoicing-sum") {
          let totalInvoicing = 0;
          field.selectedValue.forEach((item) => {
            totalInvoicing += item.percent ? parseFloat(item.percent) : 0;
          });
          if (totalInvoicing != validation.value) {
            this.notifier.notify('error', validation.message);
            isValid = false;
            return isValid;
          }
        } else if (validation.type == "age-range") {
          if (field.selectedValue["from"] && field.selectedValue["from"] != "" && field.selectedValue["to"] && field.selectedValue["to"] != "") {
            if (!(parseInt(field.selectedValue["from"]) <= parseInt(field.selectedValue["to"]))) {
              isValid = false;
              this.notifier.notify('error', validation.message);
              return isValid;
            }
          }

        } else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
          let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
          if (selectedValue > validation.value) {
            this.notifier.notify('error', validation.message);
            isValid = false;
            return isValid;
          }
        }
      });
      if (!isValid) {
        field['error'] = true;
      } else {
        field['error'] = false;
      }
      return isValid;
    } else {
      field['error'] = false;
      return true;
    }
  }

  validateFullForm() {
    let isFormValid = true;
    for (const sectionKey in this.quoteObjSection) {
      for (const field of this.quoteObjSection[sectionKey]["values"]) {
        if (field && field.required && this.quoteObjSection[sectionKey].show && field.show && !field.disabled) {
          let isValid = true;
          if (field.type == 'from-to') {
            if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
              isValid = false;
            }
          } else if (field.type == 'percent-term') {
            if (field.selectedValue && field.selectedValue.length < 1 || field.selectedValue.find(item => { return item.percent == "" || item.term == "" })) {
              isValid = false;
            }else{
              let id = field.key + "";
              this.clientService.savePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
            }
          } else {
            if (field.selectedValue == "") {
              isValid = false;
            }
          }
          if (!isValid) {
            field['error'] = true;
            this.notifier.notify('error', field.label + ' is required !');
            isFormValid = false;
            break;
          } else {
            field['error'] = false;
          }
        }
        if (field && this.quoteObjSection[sectionKey].show && field.show && field.validation && field.validation.length) {
          let isValid = true;
          if (!field.required && field.selectedValue == "") {
            isValid = true;
          } else {
            field.validation.forEach((validation) => {
              if (validation.type == "regex") {
                if (!((field.selectedValue == "" || field.selectedValue == null) && validation.allow_blank)) {
                  const regex = new RegExp(validation.value);
                  isValid = regex.test(field.selectedValue);
                  if (!isValid) {
                    this.notifier.notify('error', validation.message);
                    isValid = false;
                  }
                }
              } else if (validation.type == "total-invoicing-sum") {
                let totalInvoicing = 0;
                field.selectedValue.forEach((item) => {
                  totalInvoicing += item.percent ? parseFloat(item.percent) : 0;
                });
                if (totalInvoicing != validation.value) {
                  this.notifier.notify('error', validation.message);
                  isValid = false;
                  // return isValid;
                }
              } else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
                let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
                if (selectedValue > validation.value) {
                  this.notifier.notify('error', validation.message);
                  isValid = false;
                }
              }
            });
          }
          if (!isValid) {
            field['error'] = true;
            isFormValid = false;
            break;
          } else {
            field['error'] = false;
          }
          // return isValid;
        }
      }
      if (!isFormValid) {
        break;
      }
    }
    // console.log("quoteObjSection ====>", this.quoteObjSection);
    return isFormValid;
  }

  ondropdownSearchChange(searchValue: string, field: any) {
    searchValue.toLowerCase()
    if (searchValue && searchValue != '') {
      let allvalue = JSON.parse(JSON.stringify(field["value"]));
      field["filteredValue"] = {};
      for (const key in allvalue) {
        const tempObj = allvalue[key];
        // console.log("tempObj ====>", tempObj, key);
        if(field.key == 'country_code'){
          if (tempObj.label.toLowerCase().startsWith(searchValue.toLowerCase()) || key.toLowerCase().startsWith(searchValue.toLowerCase())) {
            field["filteredValue"][key] = tempObj;
          }
        }else if(field.key == 'state'){
          if (tempObj.label.toLowerCase().startsWith(searchValue.toLowerCase())) {
            field["filteredValue"][key] = tempObj;
          }
        }
        else{
          if (tempObj.label.toLowerCase().includes(searchValue.toLowerCase()) || tempObj.label.toLowerCase() == "other") {
            field["filteredValue"][key] = tempObj;
          }
        }
      }
    } else {
      field["filteredValue"] = JSON.parse(JSON.stringify(field["value"]));
    }
    // console.log("field.filteredValue ====>", field.filteredValue);

  }

  onSubmit() {
    if (this.validateFullForm()) {
      this.clientService.addClientRequest()
    }
  }

  onCancel() {
    this.router.navigate(['/client-master/users']);
  }
  backToClientList() {
    this.router.navigate(['/client-master/users']);
  }
}

